jQuery(document).ready(function () {
  // Quick Add button click
  $('.quick-add__button').on('click', function (e) {
    const productType = $(this).data('product-type');
    console.log('🛒 Quick Add clicked — Product Type:', productType);

    if (productType === 'Hand Creams') {
      e.preventDefault(); // stop normal add-to-cart
      $('#hand-cream-offer-popup').fadeIn(); // show popup
    }
  });

  // Confirm popup → just close popup
  $('#hand-cream-offer-confirm').on('click', function () {
    $('#hand-cream-offer-popup').fadeOut();
  });

  // Close popup using your ID
  $('#close-offer-popup').on('click', function () {
    $('#hand-cream-offer-popup').fadeOut();
  });
});
